<template>
  <div class="columns">
    <div class="background" />
    <div class="column is-6 is-flex is-centered">
      <div class="content-container is-flex is-flex-direction-column">
        <p class="is-size-3">
          <span>Factura en línea <br> de manera</span>
          <span class="has-text-weight-bold has-text-izzi-cerise"> fácil y rápida <br></span>
          con <span class="has-text-weight-bold">izzi factura digital</span>
        </p>

        <p class="is-size-5">
          Emite tus facturas de manera ilimitada y haz crecer tu negocio.
        </p>

        <img
          src="../../assets/img/izzi/sign-in.png"
          alt="sign-in illustration"
        >
      </div>
    </div>
    <div class="column is-6 is-flex is-centered">
      <div class="box">
        <form
          class="sign-in is-centered"
          @submit.prevent="onSubmit"
        >
          <img
            :src="logo"
            alt="logo"
          >
          <h1 class="title is-4 has-text-izzi-robins-egg-blue">
            factura electrónica
          </h1>

          <p class="sign-in-message">
            Inicia Sesión con tu cuenta <span class="has-text-weight-bold">izzi</span>
          </p>

          <AppInputEmail
            :value="email"
            :loading="loading"
            :disabled="loading"
            :required="true"
            @input="onChange"
            @change="onChange"
          />

          <AppInputPassword
            :value="password"
            :loading="loading"
            :disabled="loading"
            :required="true"
            @input="onChange"
            @change="onChange"
          />

          <ButtonSubmit
            :loading="loading"
            :disabled="loading"
            text="inicia sesión"
          />

          <LinkForgottenPassword />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import merge from 'lodash/merge';
import { createNamespacedHelpers, mapGetters } from 'vuex';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('auth');

const REDIRECT_URL = process.env.VUE_APP_IZZI_LOGIN || 'http://35.171.76.85:14100/fact-auth-service/FactAuth/login?response_type=code&client_id=8b4bf6893a2a4c1da0203ef466f040aa&redirect_uri=https://auth.machete-plus.kadavra.xyz/oauth/callback&scope=UserProfile.me&state=getauthz';

export default {
  name: 'SignIn',

  components: {
    AppInputEmail: () => import(/* webpackChunkName: "app-input-email" */ '@/components/AppInputEmail.vue'),
    AppInputPassword: () => import(/* webpackChunkName: "app-input-password" */ '@/components/AppInputPassword.vue'),
    LinkForgottenPassword: () => import(/* webpackChunkName: "auth-link-forgotten-password" */ '@/components/Auth/LinkForgottenPassword.vue'),
    ButtonSubmit: () => import(/* webpackChunkName: "auth-button-submit" */ '@/components/Auth/ButtonSubmit.vue'),
  },

  data() { return { loading: false }; },

  computed: merge(
    mapState({ email: ({ email }) => email, password: ({ password }) => password }),
    mapGetters({ logo: 'ui/authLogo' }),
  ),

  beforeDestroy() { this.cleanSensitiveData(); },

  methods: merge(
    mapMutations(['setValue', 'cleanSensitiveData']),
    mapActions(['signIn', 'initAuthentication']),
    {
      onChange(event) {
        const { name: accessor, value } = event.target;
        this.setValue({ accessor, value });
      },
      async onSubmit() {
        this.loading = true;

        try {
          await this.signIn();

          const to = this.$route.query.redirect || { name: 'Home' };

          this.$router.replace(to);
        } catch ({ message }) {
          this.$danger({ message });
        }

        this.loading = false;
      },
    },
  ),
};
</script>

<style lang="scss" scoped>
.columns {
  margin: 0;
}

.columns > .column {
  z-index: 2;
}

.background {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background: $izzi-gold;
}

.content-container,
.box {
  width: 400px;
}

.box {
  padding: 3rem;
}

.content-container {
  margin-right: 2rem;
}

img {
  width: 100%;
}

p.is-size-5 {
  padding-top: 1rem;
}

.is-flex-direction-column {
  flex-direction: column;
}

.sign-in-message {
  padding-bottom: 1.5rem;
}

.title.is-4.has-text-izzi-robins-egg-blue {
  margin-top: -1.75rem;
}

@media screen and (min-width: 769px) {
}
</style>
